export const downloadFileByUrlOperation = async (fileUrl: string) => {
  const a = document.createElement('a');
  a.href = fileUrl; // Your file URL here
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
